import axios from "axios";
var omniApiUrlPrefix = process.env.VUE_APP_OMNI_BASE_URL + "/api";
var securityApiUrlPrefix = process.env.VUE_APP_OMNI_SECURITY_BASE_URL + "/api";
import securityModule from "../Modules/securityModule";

let instance = axios.create({ baseURL: omniApiUrlPrefix });
instance.interceptors.request.use(function (config) {
  var user = securityModule.state.userProfile;
  config.headers["UserId"] = user?.id;
  config.headers["Username"] = user?.userName;
  config.headers["FirstName"] = user?.firstName;
  config.headers["LastName"] = user?.lastName;
  config.headers["UserEmail"] = user?.email;
  return config;
});

export async function sendFeedbackEmail(data) {
  return axios
    .post(omniApiUrlPrefix + "/shared/sendFeedbackEmail", data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

export function getUserAccess(data) {
  return axios
    .get(securityApiUrlPrefix + "/identity/getUserAccess", {
      params: {
        clientId: data.clientId,
        userId: data.userId,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return { success: false, data: error };
    });
}

export function getUser(data) {
  return axios
    .get(securityApiUrlPrefix + "/identity/getUser", {
      params: {
        userId: data,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return { success: false, data: error };
    });
}

export async function get(path, options = {}) {
  return instance
    .get(omniApiUrlPrefix + path, {
      signal: options.signal,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}

export async function getQuery(path, data, options = {}) {
  return instance
    .get(omniApiUrlPrefix + path, {
      params: data,
      signal: options.signal,
      paramsSerializer: options.paramsSerializer,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}

export async function post(path, data, options = {}) {
  return instance
    .post(omniApiUrlPrefix + path, data, { signal: options.signal })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}

export async function postQuery(path, data, options = {}) {
  return instance
    .post(omniApiUrlPrefix + path, null, {
      params: data,
      signal: options.signal,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}

export async function postQueryWithBody(subURL, query, data, options = {}) {
  return instance
    .post(omniApiUrlPrefix + subURL, data, {
      params: query,
      signal: options.signal,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}

export async function uploadFile(path, params, file, options = {}) {
  let formData = new FormData();
  formData.append("asset", file);

  return instance
    .post(omniApiUrlPrefix + path, formData, {
      params,
      "Content-Type": "multipart/form-data",
      signal: options.signal,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return { success: false, data: error };
    });
}

export async function uploadFiles(path, params, data, options = {}) {
  let formData = new FormData();
  for (const file of data.files) {
    formData.append("asset[]", file); // Append each file with the same key
  }
  return instance
    .put(omniApiUrlPrefix + path, formData, {
      params,
      "Content-Type": "multipart/form-data",
      signal: options.signal,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return { success: false, data: error };
    });
}

export async function getFile(path, data, options = {}) {
  return instance
    .get(omniApiUrlPrefix + path, {
      params: data,
      responseType: "blob",
      signal: options.signal,
    })
    .then(async (response) => {
      if (response.data.type && response.data.type.includes("json")) {
        // server returned a Result error envelope instead of a file
        return JSON.parse(await response.data.text());
      }
      return { success: true, data: response.data };
    })
    .catch((error) => {
      return { success: false, data: error };
    });
}
